'use client';

import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: ${props =>
    props.theme.getJustifyContent(props.$mobileAlignment)};

  @media ${props => props.theme.tablet} {
    justify-content: ${props =>
      props.theme.getJustifyContent(props.$desktopAlignment)};
  }
`;

export const StyledStatRingOverlay = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  height: 150px;
  border-radius: ${props => props.theme.spacing(6)};
  padding: ${props => props.theme.spacing(3)};
  box-shadow: rgba(44, 42, 38, 0.16) 0px 8px 40px,
    rgba(44, 42, 38, 0.2) 0px 24px 80px, rgba(44, 42, 38, 0.1) 0px 2px 8px,
    rgba(255, 255, 255, 0.95) 0px 1px 0px inset;
  background-color: ${props => props.theme.colors.background.base}BF;

  @media ${props => props.theme.tablet} {
    width: 250px;
    height: 250px;
    padding: ${props => props.theme.spacing(7, 8, 0, 6)};
  }

  @media ${props => props.theme.laptop} {
    width: 280px;
    height: 280px;
  }
`;

export const RingContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 122px;
  height: 100px;

  @media ${props => props.theme.tablet} {
    width: 200px;
    height: 164px;
  }

  @media ${props => props.theme.laptop} {
    width: 224px;
    height: 184px;
  }
`;

export const ScoreContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 52px;
  @media ${props => props.theme.tablet} {
    gap: ${props => props.theme.spacing(2)};
  }
`;
export const StatName = styled.p`
  text-align: center;
  ${props => props.theme.typography.subheading1};
  font-size: 11px;
  color: ${props => props.theme.colors.text.secondary};
  @media ${props => props.theme.tablet} {
    font-size: 15px;
    margin-top: ${props => props.theme.spacing(3)};
  }

  @media ${props => props.theme.laptop} {
    font-size: 21px;
  }
`;

export const MobileSVG = styled.div`
  display: block;
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const DesktopSVG = styled.div`
  display: none;
  @media ${props => props.theme.tablet} {
    display: block;
    width: 100%;
    height: 100%;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
`;

export const AnimatedRingFill = styled.path`
  fill: none;
  stroke: ${props => props.theme.colors.get(props.$fillColor)};
  stroke-dasharray: ${props => props.$pathLength};
  stroke-dashoffset: ${props => props.$dashOffset};
  transition: ${props =>
    props.$isAnimating
      ? `stroke-dashoffset ${props.$duration}s cubic-bezier(0.72, 0, 0.18, 1)`
      : 'none'};
`;

export const PillText = styled.div`
  width: 57px;
  text-align: center;
  background: ${props => props.theme.colors.get(props.$color)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  padding: ${props => props.theme.spacing(1, 3)};
  border-radius: ${props => props.theme.spacing(4)};
  font-size: 11px;

  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(1, 4)};
    width: 85px;
    font-size: 1.1rem;
  }

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(1, 6)};
    width: 96px;
    font-size: 1.25rem;
  }
`;

//Number Animation
export const RollingNumberWrapper = styled.div`
  height: 46px;
  overflow: hidden;
  width: 100%;

  @media ${props => props.theme.tablet} {
    height: 70px;
  }

  @media ${props => props.theme.laptop} {
    height: 78px;
  }
`;

export const RollingNumberColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  will-change: transform;
  transition: ${props =>
    props.$isReady
      ? `transform ${props.$duration}s cubic-bezier(0.72, 0, 0.18, 1)`
      : 'none'};
  transform: translateY(${props => props.$translateY}px);
`;

export const RollingNumberItem = styled.div`
  flex-shrink: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  ${props => props.theme.fontFamily.condensed};
  font-size: 2.5rem;
  font-weight: 500;
  letter-spacing: -1.28px;

  @media ${props => props.theme.tablet} {
    height: 70px;
    line-height: 70px;
    font-size: 4.5rem;
  }

  @media ${props => props.theme.laptop} {
    height: 78px;
    line-height: 78px;
    font-size: 5rem;
  }
`;
